import { ErrorType } from '@/classes/enums/ErrorType'
import { AxiosError } from 'axios'

export default class ErrorMessageHelper {
  public static createErrorMessage(error: AxiosError<Error>): string {
    if (!!error.isAxiosError && !error.response) {
      return ErrorType.NETWORKERROR
    }
    if (error && error.response) {
      if (error.response.data && error.response.data.Message) {
        return error.response.data.Message
      }
      if (error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      if (error.response.status) {
        switch (error.response.status) {
          case 401:
            return ErrorType.ERROR401
          case 403:
            return ErrorType.ERROR403
          case 404:
            return ErrorType.ERROR404
          case 429:
            return ErrorType.ERROR429
          case 500:
            return ErrorType.ERROR500
          default:
            return ErrorType.DEFAULT
        }
      }
    }

    return ErrorType.DEFAULT
  }
}
